export const AREAS_TYPES = {
  state: {
    pluralName: 'States',
    transcode: 't_STATES',
  },
  county: {
    pluralName: 'Counties',
    transcode: 't_COUNTIES',
  },
  province: {
    pluralName: 'Provinces',
    transcode: 't_PROVINCES',
  },
};
